export enum Feature {
	STAKING = "staking",
	STAKING_GLOBAL = "staking_global",
	CHECKOUT = "checkout"
}
